import AjaxUtil from '../../axios/axios';

export const getUserProjects = async(userNumber) => {
    try {
        return await AjaxUtil.sendRequest(`userprojects/${userNumber}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const getUserTopics = async(courseId, userNumber) => {
    try {
        return await AjaxUtil.sendRequest(`usertopics/${userNumber}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * get user mentor and collabrator projects
 */
export const getProjects = async(pageno,perpage,projecttype)=>{
    try {
        return await AjaxUtil.sendRequest(`/projects?page_no=${pageno}&per_page=${perpage}&project_type=${projecttype}&invite_status=accepted`,{}, false, { method: 'get', showError:true, isProfile:true})
    } catch (error) {
        throw error
    }
}

export const deleteProject = async(userNumber, id, type) => {
    try {
        let request = ''
        if(type) {
            request = `topic/${id}`
        } else {
            request = `userproject/${userNumber}/${id}`
        }
        return await AjaxUtil.sendRequest(request, {}, false, { method: 'delete', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const getCurrentPayment = async(userNumber, topicCode) => {
    try {
        return await AjaxUtil.sendRequest(`getCurrentPayment/${userNumber}/${topicCode}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const hasPayment = async(userNumber, topicCode) => {
    try {
        return await AjaxUtil.sendRequest(`hasPayment/${userNumber}/${topicCode}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

export const moveProject = async(data) => {
    try {
        return await AjaxUtil.sendRequest(`moveuserproject`, data, false, { method: 'post', showError: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 */
export const getPayment = async(userNumber, topicCode) => {
    try {
        return await AjaxUtil.sendRequest(`getCurrentPayment/${userNumber}/${topicCode}`, {}, false, { method: 'get', showError: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 */
export const getWhatsappUser = async() => {
    try {
        return await AjaxUtil.sendRequest("get/whatsappuser", {}, false, { method: 'get', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 */
export const addWhatsappUser = async(data) => {
    try {
        return await AjaxUtil.sendRequest("add/whatsappuser", data, false, { method: 'post', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * 
 */
export const deleteWhatsappUser = async(id) => {
    try {
        return await AjaxUtil.sendRequest(`delete/whatsappuser`, {}, false, { method: 'delete', showError: true, isProfile: true} );
    } catch (error) {   
        throw error;
    }
}

/**
 * 
 */
export const updateWhatsappUser = async(data) => {
    try {
        return await AjaxUtil.sendRequest("update/whatsappuser", data, false, { method: 'put', showError: true, isProfile: true} );
    } catch (error) {
        throw error;
    }
}

/**
 * setup TFA authenticator
 */
export const setupAuthenticator = async (data) => {
	try {
		return await AjaxUtil.sendRequest("TFA/SetupAuthenticator", data, false, { method: 'post', showError: true, isProfile: true });
	} catch (error) {
		throw error;
	}
}

/**
 * confirm TFA authenticator
 */
export const confirmAuthenticator = async (data) => {
	try {
		return await AjaxUtil.sendRequest("TFA/ConfirmAuthenticator", data, false, { method: 'post', showError: true, isProfile: true });
	} catch (error) {
		throw error;
	}
}

/**
 * disable TFA authenticator
 */
export const disableAuthenticator = async () => {
	try {
		return await AjaxUtil.sendRequest("TFA/DisableAuthenticator", {}, false, { method: 'get', showError: true, isProfile: true });
	} catch (error) {
		throw error;
	}
}

/**
 * get TFA status
 */
export const getTFAStatus = async () => {
	try {
		return await AjaxUtil.sendRequest("TFA/Status", {}, false, { method: 'get', showError: true, isProfile: true });
	} catch (error) {
		throw error;
	}
}